// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2026 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

import { IJSONSchema } from '@glittr/frontend-core/src/plugins/validation/IJSONSchema';

const schema = {
  $id: '/digital-asset-with-count-and-file-name-schema',
  type: 'object',
  required: ['id', 'creatorId', 'documentId', 'countAssigned', 'countSold'],
  properties: {
    id: {
      type: 'integer',
    },
    creatorId: {
      type: 'integer',
    },
    created: {
      type: 'string',
      format: 'date-time',
    },
    modifierId: {
      type: 'integer',
      nullable: true,
    },
    modified: {
      type: 'string',
      format: 'date-time',
      nullable: true,
    },
    documentId: {
      type: 'integer',
    },
    name: {
      type: 'string',
      nullable: true,
    },
    filename: {
      type: 'string',
      nullable: true,
    },
    extension: {
      type: 'string',
      nullable: true,
    },
    countAssigned: {
      type: 'integer',
    },
    countSold: {
      type: 'integer',
    },
  },
} as IJSONSchema;

export default schema;
